$listMaxHeight: 500px;
$groupElementWidth: 124px;
$widthInputSearch: 100%;
$inputHeight: 32px;
$inputDefaultHeight: 66px;
$gzConsoleAssetsPrefix: 'app/webcomponents/';
$gzConsoleUnderlineMonacoPath: 'assets/images/icon-error-line_monaco.svg';

:host {
  --textaria-padding: var(--spacer) calc(var(--spacer) * 3) var(--spacer) var(--spacer);
  --monaco-padding-right: 12px;
  --group-elements-border-color: var(--chart-100-pressed);
  --input-dynamic-height: 72px;
  --monaco-scrollable-element-width: 100%;
  --input-manual-resize-min-height: 67px;
  --input-manual-resize-max-height: none;
  --line-number-font: 'Montserrat Medium', 'Montserrat Regular', Montserrat;
  --help-btn-font: 'Montserrat Medium', 'Montserrat Regular', Montserrat;
  --placeholder-postion-left: 12px;
  --error-border-color: var(--red-layout-300-primary);
  --active-border-color: var(--blue-layout-301-active);
  --hover-border-color: var(--body-text-arrows-400);
  --search-min-width-container: 80%;
}

:host([isError]) {
  .search-input-container {
    .wrapper {
      border-color: var(--error-border-color);
    }
  }
}

:host(.active) {
  .search-input-container {
    .wrapper {
      border-color: var(--active-border-color);
    }
  }
}

.search-form {
  &--inner {
    position: relative;
  }
}

.help-btn {
  font-size: 11px;
  font-family: var(--help-btn-font);
}

.help-btn-icon {
  font-size: 13px;
}

.search-input-container {
  flex: 2;
  width: 0;
  min-width: var(--search-min-width-container);

  .wrapper {
    border: 1px solid var(--chart-100-pressed);
    border-radius: var(--input-border-radius) !important;
    height: var(--input-dynamic-height);
    min-height: $inputDefaultHeight;
    overflow: visible;
    background: var(--white-layout-301-level-0-elevation);

    &:hover {
      border-color: var(--hover-border-color);
    }
  }

  .hint-text {
    padding: 4px calc(2 * var(--spacer)) 4px 0;
    font-size: var(--body-size-small);
    font-style: italic;
    color: var(--main-titles-inputs-600);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .hint-text {
    display: none;

    &.visible {
      display: block;
    }
  }
}

.search-btn-container {
  flex-wrap: nowrap;
  height: $inputHeight;

  gz-button {
    display: flex;
  }
}

.info-button {
  position: absolute;
  cursor: pointer;
  top: 2px;
  right: 8px;
  z-index: 2;
}

.inline-clear-button {
  position: absolute;
  height: auto;
  right: 32px;
  top: 4px;
  z-index: 2;
  display: none;

  &.visible {
    display: block;
  }
}

.wrapper {
  height: auto;

  .container-group-list {
    flex: 1;
    line-height: 15px;

    &:not(:first-child) {
      border-left: 1px solid var(--group-elements-border-color);
    }

    gz-title {
      padding: var(--spacer) 11px;
      margin-bottom: 2px;
      cursor: pointer;
      color: var(--chart-301-icon-buttons);
    }

    gz-list-item {
      padding: 4px 11px;
    }
  }
}

.search-dropdown {
  display: none;

  &.visible {
    display: block;
  }
}

.search-dropdown {
  position: absolute;
  top: $inputHeight;
  width: 100%;
  max-height: $listMaxHeight;
  overflow: auto;
  margin-top: calc(var(--spacer) * 3);
  z-index: 10000;
  border-radius: var(--input-border-radius);
  border: 1px solid var(--blue-layout-301-active);
  background-color: var(--white-layout-301-level-0-elevation);
}

.error-container {
  display: none;
  color: var(--red-layout-300-primary);
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 2px;
  padding-right: 4px;

  &.visible {
    display: flex;
  }

  & > div {
    display: flex;
    align-items: center;
    width: 100%;

    gz-text {
      margin-left: 4px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .icon {
    width: calc(3 * var(--spacer));
    height: calc(3 * var(--spacer));
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #errorHint {
    display: none;
    text-align: right;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.hint-text {
  padding: 4px calc(2 * var(--spacer)) 4px 0;
  font-size: var(--body-size-xsmall);
  font-style: italic;
  color: var(--chart-300-icon-buttons);
}

.hint-text {
  display: none;

  &.visible {
    display: block;
  }
}

.characters-error,
#errorMessage {
  color: var(--red-layout-300-primary);
  font-size: var(--body-size-xsmall);
  font-weight: 300;
}

.characters-count {
  font-size: var(--body-size-small);
  font-weight: 300;
  justify-content: flex-end;
  display: flex;
}

:host(.is-wrapped) {
  .inline-clear-button {
    right: 5px;
    bottom: 4px;
    top: auto;
  }
}

.editor-wrapper {
  width: 100%;
}

#textareaInput {
  padding-right: 12px;
}

.monaco-editor {
  width: 100% !important;
  font-family: var(--font-family-secondary) !important;
  background-color: var(--background-transparent) !important;

  .margin {
    background-color: var(--background-transparent) !important;
  }

  .lines-content {
    background-color: var(--background-transparent) !important;
  }

  .cursors-layer .cursor {
    background: var(--main-titles-inputs-600) !important;
    border-color: var(--main-titles-inputs-600) !important;
  }

  .overflow-guard {
    width: calc(100% + 10px) !important;

    .monaco-scrollable-element {
      width: var(--monaco-scrollable-element-width, 100%) !important;
    }

    .overlayWidgets {
      .monaco-scrollable-element {
        width: 100% !important;
      }
    }
  }

  .scroll-decoration {
    height: 0px !important;
  }

  div.hover-row.status-bar {
    display: none !important;
  }

  .monaco-hover {
    color: var(--body-text-arrows-400);
    background :var(--white-layout-301-level-0-elevation);
    border-radius: var(--tooltip-border-radius);
    border-color: var(--body-text-arrows-400) !important;

    .hover-contents {
      font-size: var(--body-size) !important;
      line-height: 15px !important;
      font-family: var(--font-family) !important;
    }
  }

  .view-overlays {
    height: 100% !important;

    & > div {
      height: 100% !important;
    }
  }

  .overflowingContentWidgets {
    width: calc(100% + var(--spacer) * 2) !important;

    .suggest-widget {
      left: calc(-1 * var(--spacer)) !important;
      top: 5px !important;
      position: relative !important;
      background: var(--white-layout-301-level-0-elevation) !important;
      width: calc(100% + 5px) !important;
      border-color: var(--blue-layout-301-active) !important;
      border-radius: 4px;
      max-height: 100% !important;
      padding-top: 1px;

      .tree {
        height: calc(100% + 1px) !important;
        width: calc(100% + 2px) !important;
        margin-left: -1px !important;
        margin-top: -1px !important;
      }

      .monaco-list-row {
        width: 100% !important;
        padding-right: 0 !important;
        color: var(--main-titles-inputs-600);

        .monaco-icon-name-container {
          --font-family: var(--font-family-secondary);
        }

        &:first-child {
          border-radius: 2px 2px 0 0;
        }

        &:last-child {
          border-radius: 0 0 4px 4px;
          margin-bottom: -1px !important;
        }

        &.focused {
          width: 100% !important;
        }
      }

      .message {
        background: var(--white-layout-301-level-0-elevation) !important;
        color: var(--body-text-arrows-400) !important;
        height: 100% !important;
        display: flex;
        align-items: center;
        border-radius: var(--tooltip-border-radius);
        line-height: 15px;
        font-size: var(--body-size);
        padding: 4px 0 4px 12px !important;
      }

      .codicon-symbol-keyword {
        margin-left: var(--spacer);
      }

      .codicon-symbol-keyword:before {
        color: var(--blue-layout-400-primary);
        margin: 0 4px;
        font-size: var(--body-size);
      }
    }
  }

  .view-line {
    span {
      font-family: var(--font-family-secondary) !important;
      font-size: var(--body-size);
      color: var(--body-text-arrows-400);
    }
  }

  .monaco-list.list_id_1:not(.drop-target) .monaco-list-row:hover:not(.selected):not(.focused) {
    width: calc(100% - 4px) !important;
    left: 2px;
    background-color: var(--chart-051-hover);

    .monaco-list-row:first-of-type {
      border-top: 1px solid var(--blue-layout-301-active);
    }

    .monaco-list-row:last-of-type {
      border-bottom: 1px solid var(--blue-layout-301-active);
    }
  }

  .monaco-list {
    overflow: inherit !important;
  }
  .overlayWidgets .suggest-details-container {
    display: none !important;
  }

  .margin-view-overlays {
    border-right: 1px solid var(--chart-100-pressed) !important;

    .line-numbers {
      font-family: var(--line-number-font);
      font-size: var(--body-size);

      &.active-line-number {
        color: var(--body-text-arrows-400) !important;
      }
    }
  }
}

.monaco-editor
  .suggest-widget
  .monaco-list
  .monaco-list-row.focused.string-label
  > .contents
  > .main
  > .right
  > .readMore {
  display: none !important;
}

.monaco-editor .codicon-symbol-keyword,
.container-group-list gz-title {
  font-family: 'bitdefender' !important;
}

.monaco-editor {
  .codicon-symbol-operator,
  .codicon-symbol-value {
    margin-right: 12px !important;

    &:before {
      content: '';
    }
  }

  .codicon-symbol-keyword:before {
    content: '';
  }
}

.container-group-list gz-title {
  &:before {
    content: '';
  }
}

.monaco-editor div[aria-label^='network'] .codicon-symbol-keyword:before,
.container-group-list gz-title[class*='network']:before {
  content: '\e94c';
}

.monaco-editor div[aria-label^='process'] .codicon-symbol-keyword:before,
.container-group-list gz-title[class*='process']:before {
  content: '\e929';
}

.monaco-editor div[aria-label^='file'] .codicon-symbol-keyword:before,
.container-group-list gz-title[class*='file']:before {
  content: '\e928';
}

.monaco-editor div[aria-label^='registry'] .codicon-symbol-keyword:before,
.container-group-list gz-title[class*='registry']:before {
  content: '\e92a';
}

.monaco-editor div[aria-label^='email'] .codicon-symbol-keyword:before,
.container-group-list gz-title[class*='email']:before {
  content: '\e90c';
}

.monaco-editor div[aria-label^='alert'] .codicon-symbol-keyword:before,
.container-group-list gz-title[class*='alert']:before {
  content: '\e910';
}

.monaco-editor div[aria-label^='user'] .codicon-symbol-keyword:before,
.container-group-list gz-title[class*='user']:before {
  content: '\e9a2';
}

.monaco-editor div[aria-label^='other'] .codicon-symbol-keyword:before,
.container-group-list gz-title[class*='other']:before {
  content: '\e9d1';
}

.monaco-editor div[aria-label^='resource'] .codicon-symbol-keyword:before,
.container-group-list gz-title[class*='resource']:before {
  content: '\e9d9';
}

.container-group-list gz-title {
  display: flex;
  align-items: center;

  &:before {
    margin-right: 4px;
  }
}

.placeholder {
  position: absolute;
  z-index: 2;
  pointer-events: none;
  top: 4px;
  font-style: italic;
  text-overflow: ellipsis;
  color: var(--chart-300-icon-buttons);
  font-family: var(--font-family-secondary);
  left: var(--placeholder-postion-left);
}

:host([manualResize]) {
  --monaco-scrollable-element-width: calc(100% - 30px);

  .search-input-container {
    .wrapper {
      resize: vertical;
      overflow: hidden;
      min-height: var(--input-manual-resize-min-height);
      max-height: var(--input-manual-resize-max-height);
    }
  }
  .monaco-editor {
    .overflow-guard {
      .monaco-scrollable-element {
        width: var(--monaco-scrollable-element-width) !important;
      }
      .overlayWidgets {
        .monaco-scrollable-element {
          width: 100% !important;
        }
      }
    }
  }
}

:host([helpBtn]) {
  #textareaInput {
    padding-right: var(--monaco-padding-right, 12px);
  }

  .monaco-editor {
    .overflow-guard {
      width: calc(100% + var(--monaco-padding-right)) !important;
    }
  }
}

:host([compactMode]) {
  --monaco-editor-overlay-message-display: none;

  .monaco-editor {
    .monaco-editor-overlaymessage {
      display: var(--monaco-editor-overlay-message-display) !important;
    }
  }
}

.glyph-error {
  &.ds-icon-notification_negative {
    color: var(--red-layout-300-primary) !important;
    font-size: 16px;
  }
}

.glyph-warning {
  &.ds-icon-notification_warning {
    color: var(--orange-layout-050-warning);
    font-size: 16px;
  }
}
